export const notificationKeys = {
  all: ['notifications'] as const,
  inbox: (p: { pageNumber: number; pageSize: number; unreadOnly?: boolean }) => [...notificationKeys.all, 'inbox', p] as const,
  alerts: () => [...notificationKeys.all, 'alerts'] as const,
  orgDefaults: () => [...notificationKeys.all, 'preferences', 'org-defaults'] as const,
}
